import { render } from "./InjuryDevelopmentTrendAlysis.vue?vue&type=template&id=20470456&scoped=true"
import script from "./InjuryDevelopmentTrendAlysis.vue?vue&type=script&lang=js"
export * from "./InjuryDevelopmentTrendAlysis.vue?vue&type=script&lang=js"

import "./InjuryDevelopmentTrendAlysis.vue?vue&type=style&index=0&id=20470456&lang=scss&scoped=true"
import "./InjuryDevelopmentTrendAlysis.vue?vue&type=style&index=1&id=20470456&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20470456"]])

export default __exports__